<template>
  <div class="footFixed" v-show="closeHide">
    <div class="fixedIphone" @click="handOpenBut()">
      <div>
        <img src="../assets/img/tel.png" />
      </div>
      <div class="fixedText"><span>电话咨询</span></div>
    </div>
    <div class="fixedOrder" @click="handFooterLeagueBut()">
      <div><img src="../assets/img/form.png" /></div>
      <div class="fixedText"><span>合伙人招募咨询</span></div>
    </div>
    <div class="qr-code-dialog-wrap" v-show="qrCodeDialogVisible">
      <div
        class="qr-code-dialog-shadow"
        @click="qrCodeDialogVisible = false"
      ></div>
      <div class="qr-code-dialog">
        <img class="head" src="@/assets/img/footer/head.png" />
        <div class="content">
          <p class="p1">合伙人招募咨询</p>
          <img class="qr" src="@/assets/img/footer/new-logo-contact-qr.png" />
          <p class="p2">请截图后微信扫码咨询</p>
        </div>
        <img
          class="close"
          src="@/assets/img/footer/close.png"
          @click="qrCodeDialogVisible = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footers",
  data() {
    return {
      closeHide: true,
      qrCodeDialogVisible: false,
    };
  },
  methods: {
    handCloseBut() {
      let that = this;
      that.closeHide = false;
    },
    handOpenBut() {
      window._agl && window._agl.push(["track", ["success", { t: 19 }]]);
      window.location.href = "tel:4006618883";
      // this.noScroll();
    },
    handFooterLeagueBut() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // 微信环境跳转客服
        window.open(
          "https://work.weixin.qq.com/kfid/kfcc23d54b08e7bf8bf",
          "_blank"
        );
      } else {
        this.qrCodeDialogVisible = true;
      }
    },
  },
  mounted() {},
};
</script>
<style lang="sass" scoped>
.footFixed
  width: 100%
  height: 56px
  display: flex
  position: fixed
  bottom: 0
  background: #fff
  font-size: 14px
  color: #9F9F9F
  align-items: center
  z-index: 1000
  div
    align-items: center
    justify-content: center
    .fixedText
      margin-left: 9px
  .fixedIphone
    flex: 4
    display: flex
    height: 100%
    img
      width: 30px !important
      height: 30px
  .fixedOrder
    display: flex
    height: 100%
    flex: 6
    background: #07D1AA
    color: #fff
    img
      width: 30px !important
      height: 30px
.qr-code-dialog-wrap
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 10000
  .qr-code-dialog-shadow
    background: rgba(0,0,0,0.50)
    height: 100%
    width: 100%
  .qr-code-dialog
    top: 50%
    left: 0
    right: 0
    position: absolute
    margin: 0 auto
    width: 316px
    transform: translate(0,-50%)
    .head
      position: relative
      height: auto
      width: 100%
    .content
      margin: -24px 0 0 0
      background: #fff
      text-align: center
      padding: 44px 0 32px 0
      border-bottom-left-radius: 20px
      border-bottom-right-radius: 20px
      .p1
        font-size: 20px
        line-height: 20px
        margin-bottom: 23px
        color: #333333
        font-weight: 500
      .qr
        width: 180px
        height: 180px
      .p2
        font-size: 14px
        line-height: 18px
        margin-top: 19px
        color: #999999
    .close
      width: 34px
      height: 34px
      margin-top: 18px
</style>